<template>
	<label class="kk-checkbox">
		<input
			:id="id"
			class="kk-checkbox__input"
			type="checkbox"
			:checked="value"
			:disabled="isDisabled"
			:indeterminate.prop="isIndeterminate"
			@input.prevent="onInput"
		>
		<span class="kk-checkbox__selector">
			<KkIcon
				v-if="isIndeterminate"
				class="kk-checkbox__icon"
				name="ic_minus_line_semibold"
				size="xs"
			/>
			<KkIcon
				v-else-if="value"
				class="kk-checkbox__icon"
				name="ic_check_line_semibold"
				size="xs"
			/>
		</span>
	</label>
</template>

<script>
import KkIcon from '../../KkIcon';

export default {
	name: 'KkCheckbox',
	components: {
		KkIcon,
	},
	props: {
		value: {
			type: Boolean,
			required: true,
		},
		isDisabled: {
			type: Boolean,
			default: false,
		},
		id: {
			type: String,
			default: null,
		},
	},
	data() {
		return {
			isIndeterminate: false,
		};
	},
	watch: {
		value() {
			// when checked or unchecked, turn off indeterminate state
			if (this.isIndeterminate) {
				this.isIndeterminate = false;
			}
		},
	},
	methods: {
		/*
		* defer the control over the checked state to the parent
		* 1. revert input element is checked or not
		* 2. keep input checked was effected by emitted value
		*
		* @see https://github.com/vuejs/vue/issues/9535#issuecomment-493861467
		**/
		onInput(e) {
			const isChecked = e.target.checked;
			e.target.checked = !isChecked; // revert checked state

			// indeterminate state must be changed to unchecked
			this.$emit('input', this.isIndeterminate ? false : isChecked);
			this.updateIndeterminateState(false);
		},
		updateIndeterminateState(isIndeterminate) {
			if (this.isIndeterminate === isIndeterminate) {
				return;
			}
			this.isIndeterminate = isIndeterminate;
		},
	},
};
</script>
